import {
  getAuth,
  getMultiFactorResolver,
  type MultiFactorError,
  type MultiFactorResolver,
} from "firebase/auth";

/**
 * Checks if an error is a Firebase MFA-required error and, if so,
 * resolves it by creating a `MultiFactorResolver` and invoking the
 * provided callback to store it and navigate the user.
 *
 * @returns `true` if the error was an MFA challenge (handled), `false` otherwise.
 */
export const handleMfaError = (
  error: unknown,
  onMfaRequired: (resolver: MultiFactorResolver) => void,
): boolean => {
  const authError = error as MultiFactorError;

  if (authError?.code === "auth/multi-factor-auth-required") {
    const auth = getAuth();
    const resolver = getMultiFactorResolver(auth, authError);
    onMfaRequired(resolver);
    return true;
  }

  return false;
};
